import { Draggable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpDownLeftRight } from "@fortawesome/free-solid-svg-icons";

export const Drag = ({ id, index, title, ...props }) => {
  return (
    <Draggable draggableId={id} index={index} title={title}>
      {(provided, snapshot) => {
        return (
          <div ref={provided.innerRef} {...provided.draggableProps} {...props}>
            <div className="drag-handle" {...provided.dragHandleProps}>
              <FontAwesomeIcon icon={faUpDownLeftRight} /> {title}
            </div>
            {props.children}
          </div>
        );
      }}
    </Draggable>
  );
};
